// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-bar-container {
  position: relative;
  width: 100%;
  min-height: 60px;
  padding: 12px 16px;
  border-bottom: 1px solid #e6e6e6;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.header-bar-container .header-bar-content {
  max-width: 576px;
  width: 100%;
  position: relative;
}
.header-bar-container .header-back-button {
  cursor: pointer;
  font-size: 20px;
  color: #CC9900;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
  margin-right: 12px;
}
.header-bar-container .header-back-button:hover {
  opacity: 0.7;
}
.header-bar-container .header-logo {
  width: 40px;
  height: 40px;
  margin-right: 12px;
  object-fit: contain;
}
.header-bar-container .header-title {
  font-size: 18px;
  font-weight: 600;
  color: #262626;
  margin: 0;
}
/*# sourceMappingURL=HeaderBar.css.map */`, "",{"version":3,"sources":["webpack://./HeaderBar.less","webpack://./src/components/HeaderBar/HeaderBar.less"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gCAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ACCD;ADVA;EAYE,gBAAA;EACA,WAAA;EACA,kBAAA;ACCF;ADfA;EAkBE,eAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,kBAAA;ACAF;ADEE;EACC,YAAA;ACAH;AD5BA;EAiCE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;ACFF;ADlCA;EAwCE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;ACHF;AACA,wCAAwC","sourcesContent":[".header-bar-container {\n\tposition: relative;\n\twidth: 100%;\n\tmin-height: 60px;\n\tpadding: 12px 16px;\n\tborder-bottom: 1px solid #e6e6e6;\n\tbackground-color: #ffffff;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\t.header-bar-content {\n\t\tmax-width: 576px;\n\t\twidth: 100%;\n\t\tposition: relative;\n\t}\n\n\t.header-back-button {\n\t\tcursor: pointer;\n\t\tfont-size: 20px;\n\t\tcolor: #CC9900;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\ttransition: opacity 0.3s ease;\n\t\tmargin-right: 12px;\n\n\t\t&:hover {\n\t\t\topacity: 0.7;\n\t\t}\n\t}\n\n\t.header-logo {\n\t\twidth: 40px;\n\t\theight: 40px;\n\t\tmargin-right: 12px;\n\t\tobject-fit: contain;\n\t}\n\n\t.header-title {\n\t\tfont-size: 18px;\n\t\tfont-weight: 600;\n\t\tcolor: #262626;\n\t\tmargin: 0;\n\t}\n}\n",".header-bar-container {\n  position: relative;\n  width: 100%;\n  min-height: 60px;\n  padding: 12px 16px;\n  border-bottom: 1px solid #e6e6e6;\n  background-color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.header-bar-container .header-bar-content {\n  max-width: 576px;\n  width: 100%;\n  position: relative;\n}\n.header-bar-container .header-back-button {\n  cursor: pointer;\n  font-size: 20px;\n  color: #CC9900;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: opacity 0.3s ease;\n  margin-right: 12px;\n}\n.header-bar-container .header-back-button:hover {\n  opacity: 0.7;\n}\n.header-bar-container .header-logo {\n  width: 40px;\n  height: 40px;\n  margin-right: 12px;\n  object-fit: contain;\n}\n.header-bar-container .header-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #262626;\n  margin: 0;\n}\n/*# sourceMappingURL=HeaderBar.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
